import { AccountLogo } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { ScreenType } from '@frontend/wizard/types';

import { TelloportWhite } from '../../assets/svg/telloport-white';
import ErrorModal from '../components/error-modal/error-modal.component';
import LoadingModal from '../components/loading-modal/loading-modal.component';
import GeneralInfoButton from '../general-info/general-info-button/general-info-button.component';
import Carousel from './carousel/carousel.component';
import { DefaultHome } from './default-home/default-home.component';
import HomeLoggedInFooter from './home-loged-in-footer.component';
import useHome from './home.controller';
import LanguageSelect from './language-select/language-select.component';
import { Login } from './login/login.component';
import ManualIdentification from './manual-identification/manual-identification.component';

const ID = 'home';

const Home = () => {
    const viewProps = useHome();
    const logoClassName = 'max-h-30 h-full min-w-0 flex-1 object-contain object-left';

    return (
        <div
            id={ID}
            className='bg-foreground-default relative flex size-full flex-col items-center gap-4 overflow-hidden p-6'>
            <div className='flex items-center justify-between gap-3 self-stretch'>
                {viewProps.spotLogoUrl ? (
                    <img
                        onClick={viewProps.kioskRefresh}
                        src={viewProps.spotLogoUrl}
                        className={logoClassName}
                        alt=''
                    />
                ) : viewProps.accountId && (viewProps.spotLogoNotFound || !viewProps.spotLogoLoading) ? (
                    <AccountLogo
                        accountId={viewProps.accountId}
                        onClick={viewProps.kioskRefresh}
                        className={logoClassName}
                        alt=''
                        fallback={
                            <div
                                onClick={viewProps.kioskRefresh}
                                className='text-brand-primary size-full'>
                                <TelloportWhite className='size-full' />
                            </div>
                        }
                        fallbackSrc={viewProps.brandingLogo}
                        loadingFallback={<span className={logoClassName} />}
                        errorFallback={<span className={logoClassName} />}
                    />
                ) : (
                    <span className={logoClassName} />
                )}
                <div className='flex shrink-0 items-center justify-start gap-3'>
                    <GeneralInfoButton isOpenCallback={viewProps.setInfoModalOpen} />
                    <LanguageSelect />
                </div>
            </div>
            <HomeRender
                type={viewProps.homeScreenType}
                isLoggedIn={!!viewProps.user}
            />
            <div className='flex w-full flex-col items-center justify-start gap-6'>
                <HomeLoggedInFooter />
                <div className='text-brand-primary flex h-full max-w-full flex-row items-center justify-center align-middle'>
                    <p className='m-0 h-full py-1 text-xs text-nowrap'>powered by&nbsp;</p>
                    <TelloportWhite className='size-full' />
                </div>
                <ManualIdentification />
                <LoadingModal
                    show={viewProps.scannerResolving}
                    onClose={viewProps.stopResolving}
                />
                <ErrorModal
                    title={CommonMessage.ERRORS.UNRECOGNIZED_CODE}
                    show={!!viewProps.error}
                    message={viewProps.error}
                    onClose={viewProps.resetError}
                />
            </div>
        </div>
    );
};

export default Home;

export const HomeRender = (props: { type: ScreenType | null; isLoggedIn: boolean }) => {
    if (props.isLoggedIn) return <DefaultHome />;
    switch (props.type) {
        case ScreenType.CAROUSEL:
            return <Carousel />;
        case ScreenType.HOME:
            return <Login />;
        case ScreenType.LICENSE_BUTTONS:
        default:
            return <DefaultHome />;
    }
};
